var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinDollar = function SvgCoinDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#66758F",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm9-4.106a2.556 2.556 0 0 1 2.044 1.273 1 1 0 1 1-1.733 1 .556.556 0 0 0-.533-.278H7.222a.556.556 0 1 0 0 1.111h1.556A2.555 2.555 0 0 1 9 12.101v.399a1 1 0 1 1-2 0v-.394a2.555 2.555 0 0 1-2.044-1.273 1 1 0 1 1 1.733-1 .555.555 0 0 0 .533.278h1.556a.556.556 0 0 0 0-1.111H7.222A2.556 2.556 0 0 1 7 3.899V3.5a1 1 0 0 1 2 0v.394Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCoinDollar;